import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Input from "../../../../components/common/inputs/Input";
import Button from "../../../../components/common/button/Button";
import Table from "../../../../components/common/table/Table";
import { courseSupportColums } from "../../../../constant/tables-columns/tablesColums";
import { courseSupportValidation } from "../../../../utils/validation/course/courseSupportValidation";
import { warningMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import Select from "../../../../components/common/inputs/Select";

const { forwardRef, useImperativeHandle } = React;

const SupportPlatforms = forwardRef(({ supportData, handleSupport }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {
      setSupport([]);
      setLearn(null);
    },
  }));

  const [learn, setLearn] = useState(null);
  const [support, setSupport] = useState([]);

  const formHandler = async (values, { resetForm }) => {
    let isExist = support.filter((item) => {
      return item.platform == values.platform;
    });
    if (!isExist.length) {
      setSupport((prev) => [...prev, { ...values }]);
      setLearn(null);
      resetForm();
    } else {
      warningMessage("این مورد از قبل موجود است.");
    }
  };

  const onDelete = (data) => {
    const newsupport = support.filter((item) => item.platform != data.platform);
    setSupport(newsupport);
  };

  const handleNewsupport = () => {
    handleSupport(support);
    setShowModal(false);
  };

  useEffect(() => {
    if (supportData?.length) {
      setSupport(supportData);
    }
  }, [supportData]);


  return (
    <>
      <div
        className={`admin-edit-backdrop fixed top-0 right-0 w-full h-full transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        hidden={!showModal}
        role="dialog"
        aria-label="پشتیبانی دوره"
        aria-modal="true"
        className={`admin-edit-drawer w-full h-full overflow-y-scroll  bg-white shadow-md z-40 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${
          showModal && "!left-0 is-open"
        }`}
      >
        <div className="flex w-full items-center justify-between">
          <h4>پلتفرم های پشتیبانی</h4>
          <Button
            onClick={handleNewsupport}
            type="button"
            color="primary"
            text="بازگشت"
          />
        </div>
        <Formik
          enableReinitialize
          initialValues={{
            platform: learn?.platform || "",
            link: learn?.link || "",
            account: learn?.account || "",
          }}
          validationSchema={courseSupportValidation}
          onSubmit={formHandler}
        >
          {() => (
            <Form>
              <div className="grid gap-6 my-4 md:grid-cols-2">
                {/* <Input
                  name={""}
                  placeholder="نام"
                  label="نام"
                  type="text"
                /> */}
                <Select
                  name="platform"
                  placeholder="انتخاب پلتفرم"
                  label="پلتفرم"
                >
                  <option value={"eitaa"}>ایتا</option>
                  <option value={"bale"}>بله</option>
                  <option value={"rubika"}>روبیکا</option>
                </Select>
                <Input
                  name={"link"}
                  placeholder="لینک"
                  label="لینک"
                  type="text"
                />
                <Input
                  name={"account"}
                  placeholder="اکانت"
                  label="اکانت"
                  type="text"
                />
              </div>
              <div className="mt-2 flex flex-wrap gap-3">
                {learn && (
                  <Button
                    type="button"
                    onClick={() => setLearn(null)}
                    text={"بازگشت"}
                    color={"danger"}
                  />
                )}
                <Button text={learn ? "ویرایش" : "افزون"} color={"primary"} />
              </div>
            </Form>
          )}
        </Formik>

        <Table
          columns={courseSupportColums}
          rows={support}
          onDelete={onDelete}
          notFoundMessage="شما هنوز هیچ چیزی اضافه نکرده اید"
        />
      </div>
    </>
  );
});
export default SupportPlatforms;
